module.exports = __webpack_public_path__ + "img/good.7b97e9b8.png";